// Runtime version service. Fetches active consent_version from `new_consent` database table.
import API_BASE from './apiBase';
import { compareConsentVersions } from './consentVersionUtils';

const CACHE_TTL_MS = 5000;
const _cache = new Map();

export async function getVersion(tenantId = null, consentType = null) {
  const now = Date.now();
  const tenant = tenantId || Number(localStorage.getItem('tenant_id')) || null;
  const normalizedType = consentType
    ? String(consentType).trim().replace(/[_-]/g, ' ').toLowerCase()
    : '';
  const cacheKey = `${tenant || ''}|${normalizedType}`;
  const cached = _cache.get(cacheKey);
  if (cached && now - cached.timestamp < CACHE_TTL_MS) return cached.version;

  try {
    const url = tenant ? `${API_BASE}/manager/new-consents?tenant_id=${tenant}` : `${API_BASE}/manager/new-consents`;
    const resp = await fetch(url, { cache: 'no-store' });
    if (resp.ok) {
      const data = await resp.json();
      const rows = data?.data || [];
      if (Array.isArray(rows) && rows.length > 0) {
        let match = null;
        if (normalizedType) {
          const matches = rows.filter(r => {
            const type = r.consent_type || r.type || r.consent_type_name || '';
            return String(type).trim().replace(/[_-]/g, ' ').toLowerCase() === normalizedType;
          });
          if (matches.length > 0) {
            matches.sort((a, b) => compareConsentVersions(b.consent_version || b.version || '1.0', a.consent_version || a.version || '1.0'));
            match = matches[0];
          }
        } else {
          const validRows = [...rows].sort((a, b) => compareConsentVersions(b.consent_version || b.version || '1.0', a.consent_version || a.version || '1.0'));
          match = validRows[0];
        }

        if (match && (match.consent_version || match.version)) {
          const version = String(match.consent_version || match.version).trim();
          _cache.set(cacheKey, { version, timestamp: now });
          return version;
        }
      }
    }
  } catch (err) {
    console.warn('Failed to fetch version from new_consent DB table', err);
  }
  return cached?.version || (normalizedType ? null : '1.0.0');
}

export function clearCache() {
  _cache.clear();
}

export default { getVersion, clearCache };
